import React from "react";
import { Navigate } from "react-router-dom";

const ADMIN_EMAILS = [
  "larybetancourt07@gmail.com",
  "afgarridof@gmail.com",
];

function getLoggedUserEmail() {
  const directEmail = localStorage.getItem("userEmail");
  if (directEmail) {
    return String(directEmail).trim().toLowerCase();
  }

  const petfamUserRaw = localStorage.getItem("petfamUser");
  if (petfamUserRaw) {
    try {
      const parsed = JSON.parse(petfamUserRaw);
      if (parsed?.email) {
        return String(parsed.email).trim().toLowerCase();
      }
    } catch (error) {
      console.error("Error leyendo petfamUser del localStorage:", error);
    }
  }

  return "";
}

export default function ProtectedAdminRoute({ children }) {
  const token = localStorage.getItem("token");
  const email = getLoggedUserEmail();

  const isAllowed = Boolean(token) && ADMIN_EMAILS.includes(email);

  if (!isAllowed) {
    return <Navigate to="/interfaz" replace />;
  }

  return children;
}